import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('RequestForm.xero.XeroCreateContactPopup', {
    doneButtonTitle: 'Create contact',
    validationErrorText: 'Please fill in mandatory fields',
    invalidContactName: 'Contact name cannot contain the following symbols: "<". ">", "&#"',
    namePlaceholder: 'Enter contact name',
    accountNamePlaceholder: 'Enter account name',
    firstNamePlaceholder: 'Enter primary person first name',
    lastNamePlaceholder: 'Enter primary person last name',
    emailPlaceholder: 'name@email.com',
    skypeNamePlaceholder: 'Enter Skype name/number',
    dropdownPlaceholder: 'Select option',
    phoneLabel: 'Phone',
    faxLabel: 'Fax',
    mobileLabel: 'Mobile',
    directDialLabel: 'Direct dial',
    skypeNameLabel: 'Skype name/number',
    doneButtonText: 'Create',
    contactInformationHeader: 'Contact Information',
    nameLabel: 'Contact name',
    accountNameLabel: 'Account name',
    firstNameLabel: 'Primary person first name',
    lastNameLabel: 'Last name',
    emailLabel: 'Email',
    billingAddressHeader: 'Billing address',
    deliveryAddressHeader: 'Delivery address',
    sameAsBillingCheckboxLabel: 'Same as Billing Address',
    invalidSortCode: 'Sort code should be 6 digits',
    invalidBankAccountDetails: 'Bank account number should be 8 digits',
});
